// tslint:disable: completed-docs
/**
 * Own area for container
 */
import {SAILS_APP_NAME} from 'Constant';
export const OFFER_DISPLAY_STORE = 'OFFER_DISPLAY';

export const SET_DEFAULT_STATE = `${SAILS_APP_NAME}/${OFFER_DISPLAY_STORE}/SET_DEFAULT_STATE`;
export const SET_CURRENT_OFFERS = `${SAILS_APP_NAME}/${OFFER_DISPLAY_STORE}/SET_CURRENT_OFFERS`;
export const SET_CURRENT_OFFERS_SUCCESS = `${SAILS_APP_NAME}/${OFFER_DISPLAY_STORE}/SET_CURRENT_OFFERS_SUCCESS`;
export const SET_CURRENT_OFFERS_FAILED = `${SAILS_APP_NAME}/${OFFER_DISPLAY_STORE}/SET_CURRENT_OFFERS_FAILED`;
export const SET_ADDITIONAL_CONTENT_DOWNLOADED = `${SAILS_APP_NAME}/${OFFER_DISPLAY_STORE}/SET_ADDITIONAL_CONTENT_DOWNLOADED`;

/**
 * Container-Ids and constants for dynamic rendering of Offer-Card
 */

// Offer Headline
export const OFFER_CARD_OFFER_HEADLINE = 'gigakombi-offer-headline';
export const OFFER_CARD_OFFER_SUBLINE = 'gigakombi-offer-subline';
export const OFFER_CARD_OFFER_COUNTER_HEADLINE = 'gigakombi-offer-offer-counter-headline';
// Multi-Divider

export const OFFER_CARD_MULTIDIVIDER_HEADLINE = 'gigakombi-multi-divider-headline';
export const OFFER_CARD_MULTIDIVIDER_IMAGES = 'gigakombi-multi-divider-images';

// Benefit-Liste
export const OFFER_CARD_BENEFITLIST_HEADLINE = 'gigakombi-benefitlist-headline';
export const OFFER_CARD_BENEFITLIST_IMAGE = 'gigakombi-benefitlist-image';
export const OFFER_CARD_BENEFITLIST_LIST = 'gigakombi-benefitlist-list';

// Offer-Price
export const OFFER_CARD_OFFER_PRICE = 'gigakombi-offer-price';
export const OFFER_CARD_OFFER_PRICE_CTA = 'gigakombi-price-cta';
export const MAX_LEGALTEXT_ITEMS = 4;

// Price-Details
export const OFFER_CARD_PRICE_DETAILS = 'gigakombi-accordion';
export const OFFER_CARD_PRICE_DETAILS_CONTENT = 'gigakombi-accordion-item';

// Price Composition
export const OFFER_CARD_PRICE_COMPOSITION_MONTHLY = 'gigakombi-price-composition-monthly';
export const OFFER_CARD_PRICE_COMPOSITION_ONETIME = 'gigakombi-price-composition-onetime';

// Healines
export const OFFER_CARD_PRICE_COMPOSITION_MONTHLY_HEADLINE = 'gigakombi-basket-summary-headline-monthly';
export const OFFER_CARD_PRICE_COMPOSITION_ONETIME_HEADLINE = 'gigakombi-basket-summary-headline-onetime';

// Total discount ("green" line)
export const OFFER_CARD_PRICE_DETAILS_TOTAL_DISCOUNT_LABEL = 'gigakombi-total-discount-label';
export const OFFER_CARD_PRICE_DETAILS_TOTAL_DISCOUNT = 'gigakombi-total-discount';
export const OFFER_CARD_PRICE_DETAILS_TOTAL_ONETIME_DISCOUNT_LABEL = 'gigakombi-total-onetime-discount-label';
export const OFFER_CARD_PRICE_DETAILS_TOTAL_ONETIME_DISCOUNT = 'gigakombi-total-onetime-discount';

export const OFFER_CARD_PRICE_DETAILS_BASKET_SUMMARY_MONTHLY = 'gigakombi-basket-summary-monthly';
export const OFFER_CARD_PRICE_DETAILS_BASKET_SUMMARY_ONETIME = 'gigakombi-basket-summary-onetime';

export const PRICE_COMPOSITION_ICON = {
    Mobile: '/media/img/icons/mobile.svg',
    Fixed: '/media/img/icons/broadband.svg',
    TV: '/media/img/icons/tv.svg',
    RedPlus: '/media/img/icons/add-sim.svg',
};
